import type { FaireProductEntity } from "../../entity_types/product";

export const p_2nhhqvyf7e: FaireProductEntity = {
  token: "p_2nhhqvyf7e",
  type: "product",
  name: '9.5" Arizona Color Me Plush™ Saguaro',
  brandToken: "b_40uiyujpi6",
  brandName: "Plushology® by RGU",
  imageUrl:
    "https://cdn.faire.com/fastly/3842005335999e928bcf1e08c9589da283835a4bc8204c3a4d4ae315cd3b044b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bea7b970c9780c88d7adace7ed0080b4f5dd41b24a42fcdefa1bcf63719888db.jpeg",
    "https://cdn.faire.com/fastly/ffe37b7c6d6d862c25de96eed7d463f2aa4dfcd2260bb41f850f708336a9a897.jpeg",
    "https://cdn.faire.com/fastly/51770fe1a14f86e3cdb9b3b9e73bc8a9d514260247d93e5b775e3014580ddbf4.jpeg",
  ],
  priceDollars: 12.5,
  description:
    'What a cool cactus! You can color on it with the provided markers or use any other washable markers you may already own. It is machine washable, so you can wash it and start the fun all over! This saguaro has "Arizona" printed on it along with related icons. Icons include the state flag, a kokopelli, a saguaro, and even a Route 66 road sign. Top these things off by giving your bear a name and birthday.',
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:29.252Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
